<!-- <app-progress-bar [hidden]="!loaderService.showMain"></app-progress-bar> -->
<div id="loading" [hidden]="!loaderService.showMain"></div>
<!-- <div class="absolute w-full h-full flex justify-center items-center text-xs-center" *ngIf="!isLoading && !authService.isLoggedIn">
    <p-progressSpinner strokeWidth="6" [style]="{'height': '60px'}"></p-progressSpinner>
</div> -->
